module.exports = __webpack_public_path__ + "static/media/dog_walk_interrupted.2d2b18e9.svg";